exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/style-loader!./node_modules/css-loader!./node_modules/postcss-loader?{}!./node_modules/sass-loader/lib/loader.js!./frontend/styles/index.scss
// module id = 537
// module chunks = 0